import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { AlertTriangle } from "lucide-react";

export function LegalBanner() {
  const { t } = useLanguage();
  return (
    <div
      data-testid="legal-banner"
      className="w-full border-b border-[hsl(var(--warning))]/25 bg-[hsl(var(--warning))]/[0.06] text-[hsl(var(--warning))]"
    >
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-6 py-2">
        <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2.5} />
        <p className="font-mono text-[11px] uppercase tracking-[0.2em]">
          {t.disclaimer_short}
        </p>
      </div>
    </div>
  );
}
